import SocketIO from 'socket.io-client';
import { useDispatch, useSelector } from 'react-redux';
import { createContext, useEffect, useRef, useState } from 'react';
import { newOrderNotify } from '../redux/actions/orders.action';

const SocketContext = createContext();

export const SocketContextProvider = (props) => {
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const socketRef = useRef(null);
    const [socket, setSocket] = useState(null);

    // Crear y limpiar el socket dentro del effect para respetar StrictMode
    useEffect(() => {
        const newSocket = SocketIO(process.env.REACT_APP_API_URL, {
            transports: ['websocket'],
            path: '/socket.io',
        });

        newSocket.on('connect', () => {
            console.log('Socket connected.');
        });
        newSocket.on('disconnect', (reason) => {
            console.log(`Socket disconnected: ${reason}`);
        });

        socketRef.current = newSocket;
        setSocket(newSocket);

        return () => {
            newSocket.off('connect');
            newSocket.off('disconnect');
            newSocket.disconnect();
            socketRef.current = null;
        };
    }, []);

    // Listener de nuevas órdenes — se re-registra si cambia el userId
    useEffect(() => {
        if (!socket || !auth.userId) return;

        const channel = `${auth.userId}_SOCKET_NEW_ORDER`;

        const handleNewOrder = (data) => {
            dispatch(newOrderNotify(data));
        };

        socket.on(channel, handleNewOrder);

        return () => {
            socket.off(channel, handleNewOrder);
        };
    }, [auth.userId, dispatch, socket]);

    return <SocketContext.Provider value={{ socket }} {...props} />;
};